/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JsonApiResource } from '@irian-ro/abstract-resource';
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';
import { Observable } from 'rxjs';

export abstract class AbstractLegalEntitySearchService {
  abstract searchLocalLegalEntity(event: { query: string }): Observable<JsonApiResource<LegalEntityModel[], any>>;

  abstract searchAnafLegalEntity(event: { query: string }): Observable<JsonApiResource<LegalEntityModel[], any>>;

  abstract searchCofaceLegalEntity(
    countryIsoCode: string,
    vatCode: string
  ): Observable<JsonApiResource<LegalEntityModel[], any>>;
}
